import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumber',
  standalone: true
})
export class ToNumberPipe implements PipeTransform {

  transform(value: any): number {
    try {
      value = Number(value);
    } catch (error) {
      value = 0
    }

    return value;
  }

}
